import { useLastSignRequest } from 'app/domains/esigning/hooks/useLastSignRequest';
export const useSignatory = (id) => {
    const { lastSignRequest } = useLastSignRequest();
    const { signatories = [] } = lastSignRequest || {};
    const match = signatories.find(signatory => signatory.id === id);
    return match;
};
